import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useWidgetContext } from '../../hooks/use-widget-context';
import { Page } from '../../types/constants';
import { OtherContacts } from '../other-contacts';
import { Voip } from '../voip';
export const VoipView = () => {
    const { platform, displayPanel, isWebview, isPreAuth } = useWidgetContext();
    const [openBottomSheet, setOpenBottomSheet] = useState(false);
    const toggleBottomSheet = () => {
        setOpenBottomSheet((prev) => !prev);
    };
    useEffect(() => {
        if (platform === 'mobile' && displayPanel === Page.OtherContacts) {
            setOpenBottomSheet(true);
        }
    }, [platform, displayPanel]);
    if (platform === 'mobile' && !isWebview && !isPreAuth) {
        return (_jsxs(React.Fragment, { children: [_jsx(Voip, { toggleBottomSheet: toggleBottomSheet }), _jsx(OtherContacts, { openBottomSheet: openBottomSheet, toggleBottomSheet: toggleBottomSheet })] }));
    }
    if (displayPanel === Page.Voip) {
        return _jsx(Voip, {});
    }
    return _jsx(OtherContacts, {});
};
